const groupPrefix = 'parameters'
export const apiProductsParameters = {
	fetchParameters: async () => {
		const { data } = await apiCommon<IProductParameter[]>(`${groupPrefix}`, { method: 'GET', skipSSRPayload: true })
		const response = data.map((item) => {
			return ProductParameter(item)
		})
		return response
	},

	fetchParameter: async (parameterID: number) => {
		const { data } = await apiCommon<IProductParameter>(`${groupPrefix}/${parameterID}`, { method: 'GET' })
		return ProductParameter(data)
	},

	addParameter: async (productParameterData: Partial<IProductParameterModel>) => {
		const { data } = await apiCommon<IProductParameter>(`${groupPrefix}`, {
			method: 'POST',
			body: productParameterToJSON(productParameterData),
		})
		return ProductParameter(data)
	},

	updateParameter: async (productParameterData: Partial<IProductParameterModel>) => {
		const { data } = await apiCommon<IProductParameter>(`${groupPrefix}/${productParameterData.id}`, {
			method: 'PUT',
			body: productParameterToJSON(productParameterData),
		})
		return ProductParameter(data)
	},

	deleteParameter: async (productParameterID: string) => {
		const data = await apiCommon<string>(`${groupPrefix}/${productParameterID}`, { method: 'DELETE' })
		return data
	},
}
